// extracted by mini-css-extract-plugin
module.exports = {"container":"_2-g4n","isTop":"_2nGzj","withPagination":"_2aEBC","innerContainer":"sPeUt","pagination":"_1HMtr","arrow":"_2Y4MD","page":"_1uRoH","active":"_2n6cX"};